export default {
  header: ['D', 'P', 'Ø Máx.', 'Ø Min.'],
  data: [
    ['1/16', '27', '6,3', '6,3'],
    ['1/8', '27', '8,7', '8,7'],
    ['1/4', '18', '11,2', '11,2'],
    ['3/8 ', '18', '14,7', '14,7'],
    ['1/2', '14', '18,3', '18,3'],
    ['3/4', '14', '23,5', '23,5'],
    ['1”', '11.1/2', '29,5', '29,5'],
    ['1” 1/4', '11.1/2', '38,1', '38,1'],
    ['1” 1/2', '11.1/2', '44', '44'],
    ['2”', '11.1/2', '56,3', '56,3'],
    ['2” 1/2', '8', '67', '67'],
  ],
};
